import Campaigns from './campaigns'

export default Campaigns
